import type { IFraudReportLinkType } from '@/types/api';

export const getPersonalLink = (params: string): string => {
  return `/api/v4/personalLink/${encodeURIComponent(params)}.json`;
};

export const getProductLink = (params: string): string => {
  return `/api/v4/zarinLink/checkout/${encodeURIComponent(params)}.json`;
};

export const couponInquiry = (): string => {
  return '/pg/v4/checkout/CouponInquiry.json';
};

export const receipt = (): string => {
  return '/pg/v4/receipt/zarinLink.json';
};
export const fraudReports = (linkType: IFraudReportLinkType, zarinId: string): string => {
  return `/api/v4/fraudReports/${linkType}/${zarinId}`;
};
